import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-modalpopup',
    templateUrl: 'modalPopup.component.html',
    standalone: false
})
export class ModalPopupComponent implements OnInit {

    modalRef: BsModalRef;
    @Output() cancel = new EventEmitter();
    @Output() update = new EventEmitter();
    @Output() save = new EventEmitter();
    @Output() delete = new EventEmitter();
    @Output() formCancel = new EventEmitter();
    @Input() btnText: string;
    @Input() txtModule: string = "";
    constructor() { }

    ngOnInit(): void { }
    btnClick(button) {
        if (this.btnText === 'save') {
            this.save.emit(button);
        } else if (this.btnText === 'cancel') {
            this.cancel.emit(button);
        } else if (this.btnText === 'update') {
            this.update.emit(button);
        } else if (this.btnText === 'delete') {
            this.delete.emit(button);
        }
    }

}
